
###
# Модель для конфигурации темы (скина)
###
App.Skin = DS.Model.extend
  is_published:   DS.attr 'boolean'
  is_selected:    DS.attr 'boolean'
  secure_id:      DS.attr 'string'
  organization:   DS.belongsTo 'organization'

  configuration:  DS.attr 'mixed'
  skin_media:     DS.attr 'mixed'

  platform: DS.attr 'string'

  theme: DS.belongsTo 'theme', async: true

  select: ->
    @nonRESTAction('PUT', 'select')

  publish: ->
    @nonRESTAction('POST', 'publish')

  reset: ->
    @nonRESTAction('POST', 'reset')

  configure: (param, value) ->
    data       = { skin: configuration: value }
    serializer = @get('modelSerializer')

    @nonRESTAction('PUT', "configure/#{param}", data)
    .then (data) =>
      return unless data?.skin?.configuration?
      conf = serializer.transformFor('mixed').deserialize(data.skin.configuration)
      @set('configuration', conf)

  removePhoto: (param) ->
    serializer = @get('modelSerializer')
    @nonRESTAction('DELETE', "configure/#{param}")
    .then (data) =>
      return unless data?.skin?.skin_media?
      sm = serializer.transformFor('mixed').deserialize(data.skin.skin_media)
      @set('skin_media', sm)

  uploadPhoto: (param, file) ->
    serializer = @get('modelSerializer')
    promise = @fileUpload("photo/#{param}", file)

    promise.then (data) =>
      return unless data?.skin?.skin_media?
      sm = serializer.transformFor('mixed').deserialize(data.skin.skin_media)
      @set('skin_media', sm)

    promise
